import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  softwareUpdateOverviewService,
  type OverviewParams,
  type OverviewTimeseriesParams,
  type OverviewEventsParams,
  type OverviewStuckInstallsParams,
} from '@/lib/software-update-overview.service';

export const softwareUpdateOverviewKeys = {
  all: ['software-update-overview'] as const,
  overview: (params: OverviewParams) =>
    [...softwareUpdateOverviewKeys.all, 'overview', params] as const,
  timeseries: (params: OverviewTimeseriesParams) =>
    [...softwareUpdateOverviewKeys.all, 'timeseries', params] as const,
  events: (params: OverviewEventsParams) =>
    [...softwareUpdateOverviewKeys.all, 'events', params] as const,
  stuckInstalls: (params: OverviewStuckInstallsParams) =>
    [...softwareUpdateOverviewKeys.all, 'stuck-installs', params] as const,
};

export function useSoftwareUpdateOverview(params: OverviewParams) {
  return useQuery({
    queryKey: softwareUpdateOverviewKeys.overview(params),
    queryFn: () => softwareUpdateOverviewService.getOverview(params),
    enabled: !!params.since && !!params.until,
    placeholderData: keepPreviousData,
  });
}

export function useOverviewEventsTimeseries(params: OverviewTimeseriesParams) {
  return useQuery({
    queryKey: softwareUpdateOverviewKeys.timeseries(params),
    queryFn: () => softwareUpdateOverviewService.getEventsTimeseries(params),
    enabled: !!params.since && !!params.until && params.bucket_seconds > 0,
  });
}

export function useOverviewEvents(params: OverviewEventsParams) {
  return useQuery({
    queryKey: softwareUpdateOverviewKeys.events(params),
    queryFn: () => softwareUpdateOverviewService.listEvents(params),
    enabled: !!params.since && !!params.until,
  });
}

export function useOverviewStuckInstalls(params: OverviewStuckInstallsParams) {
  return useQuery({
    queryKey: softwareUpdateOverviewKeys.stuckInstalls(params),
    queryFn: () => softwareUpdateOverviewService.listStuckInstalls(params),
    enabled: params.stuck_after_seconds > 0,
    placeholderData: keepPreviousData,
  });
}
